import React from "react";

import SEO from "@src/components/SEO";
import Layout from "@components/Layout";
import { Box, ThemeProvider } from "@mui/material";
import { getTwentyFiveTheme } from "@src/gatsby-theme-material-ui-top-layout/theme";
import Nav from "@src/components/Taxonomy/nav2";
import Content from "@src/components/Taxonomy/content";
import Toolbar from "@src/components/Taxonomy/toolbar";

const TaxonomyPage = () => {

  return (
    <Layout reverseColor={true} noHeaderBg={true}>
      <ThemeProvider theme={getTwentyFiveTheme}>
        <Box
          sx={{
            position: "relative",

            minHeight: {
              xs: "auto",
              md: "calc(100vh - 50px)",
            },
            zIndex: "2",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              inset: 0,
              background: `linear-gradient(180deg, #0A0C0C 0%, #1B0F24 45.62%, #3C1450 80.82%)`,
              zIndex: -10,
              marginTop: "-70px",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              height: "100px",
              background: `linear-gradient(180deg, #240F3800 0%, #240F38 100%)`,
              zIndex: -9,
              marginTop: "-70px",
            }}
          />

          <Toolbar />

          <Nav />

          <Content />
        </Box>
      </ThemeProvider>
    </Layout>
  );
};

export default TaxonomyPage;

export const Head = () => (
  <SEO
    title="Prompt Injection Taxonomy | Pangea"
    description="Explore the Pangea Prompt Injection Taxonomy using the interactive web experience"
    heroImage="/taxonomy/poster2.png"
    pathname="/taxonomy/"
  />
);
